import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireAdminRoute } from '@/lib/utils/route-auth.utils';

export const Route = createFileRoute('/_authenticated/_admin')({
  beforeLoad: ({ context }) => requireAdminRoute(context),
  component: AdminLayout,
});

function AdminLayout() {
  return <Outlet />;
}
